import type { ChartOrderLineKind } from './chartOrderLineUtils';

export type ChartOverlayKey = 'tradeMarks' | 'position' | 'limitOrders' | 'stopOrders' | 'positionTpSl';

export type ChartOverlayVisibility = Record<ChartOverlayKey, boolean>;

export const DEFAULT_CHART_OVERLAY_VISIBILITY: ChartOverlayVisibility = {
  tradeMarks: true,
  position: true,
  limitOrders: true,
  stopOrders: true,
  positionTpSl: true,
};

export const CHART_OVERLAY_PREFERENCE_ITEMS: ReadonlyArray<{
  key: ChartOverlayKey;
}> = [{ key: 'tradeMarks' }, { key: 'position' }, { key: 'limitOrders' }, { key: 'stopOrders' }, { key: 'positionTpSl' }];

export function normalizeOverlayVisibility(visibility: Partial<ChartOverlayVisibility> | undefined): ChartOverlayVisibility {
  return { ...DEFAULT_CHART_OVERLAY_VISIBILITY, ...visibility };
}

export function isTradeMarksVisible(visibility: Partial<ChartOverlayVisibility> | undefined): boolean {
  return normalizeOverlayVisibility(visibility).tradeMarks;
}

export function isOrderLineOverlayVisible(kind: ChartOrderLineKind, visibility: ChartOverlayVisibility): boolean {
  switch (kind) {
    case 'limit':
      return visibility.limitOrders;
    case 'trigger':
      return visibility.stopOrders;
    case 'positionTp':
    case 'positionSl':
      return visibility.positionTpSl;
  }
}
